import request from '@hotmart/request'
import { USER_INTENTION_REQUEST_IDENTIFIERS } from './constants'
import { IUserIntentionQualification } from './user-intention-qualification.interfaces'
import './user-intention-qualification.request'

export const getUserIntentionQualification = async (): Promise<IUserIntentionQualification> =>
  request(USER_INTENTION_REQUEST_IDENTIFIERS.GET_USER_INTENTION_QUALIFICATION)
